import { createSlice } from '@reduxjs/toolkit';
import { apiCallBegan } from '../../../../store/middleware/apiActions';
import { loansAdded, loansUpdated, loansDeleted } from './loans';

const slice = createSlice({
	name: 'loan',
	initialState: null,
	reducers: {
		loanSaved: (loan, action) => action.payload,
		loanReceived: (loan, action) => action.payload,
		loanReseted: () => null,
	},
});

export const deleteLoan = loanId => (dispatch, getState) => {
	dispatch(
		apiCallBegan({
			api: 'hammurabi',
			url: `/loans/${loanId}`,
			method: 'DELETE',
			onSuccess: loansDeleted.type,
		})
	);
};

export const getLoan = loanId => (dispatch, getState) => {
	dispatch(
		apiCallBegan({
			api: 'hammurabi',
			url: `/loans/${loanId}`,
			method: 'GET',
			onSuccess: loanReceived,
		})
	);
};

export const saveLoan =
	(loan, next = null, toast = '') =>
	(dispatch, getState) => {
		let method = '';
		let url = '';
		let onSuccess = '';

		delete loan.user;
		delete loan.loan;
		delete loan.previous_loan;
		delete loan.documents;
		delete loan.payments;
		delete loan.proposals;
		delete loan.manager;
		delete loan.transactions;

		if (loan.id === undefined) {
			method = 'POST';
			url = '/loans';
			if (loan.loan_id === '') loan.loan_id = null;
			if (loan.previous_loan_id === '') loan.previous_loan_id = null;
			loan.requested_at = new Date();
			loan.created_at = new Date();
			loan.updated_at = new Date();
			onSuccess = loansAdded.type;
		} else {
			method = 'PUT';
			url = `/loans/${loan.id}`;
			onSuccess = loansUpdated.type;
			delete loan.id;
			loan.updated_at = new Date();
			Object.keys(loan).forEach(x => {
				loan[x] === null && delete loan[x];
			});
		}

		if (next) {
			onSuccess = next.type;
		}

		dispatch(
			apiCallBegan({
				api: 'hammurabi',
				url,
				method,
				data: loan,
				onSuccess,
				toastNotification: toast,
			})
		);
	};

export const { loanCreated, loanSaved, loanReceived, loanReseted } = slice.actions;

export default slice.reducer;
